/** Testo cercato nel catalogo: contano solo lettere e cifre, senza maiuscole
 * (osservazioni del 30/10/2026, #17). `tn 1080`, `tn1080` e `TN/1080` trovano
 * `TN-1080`, e viceversa. È lo stesso confronto del backend
 * (`backend/products/ricerca.py`). */
// Con `new RegExp`: il target ES5 di tsc non accetta il flag `u` letterale.
const NON_ALFANUMERICO = new RegExp('[^\\p{L}\\p{N}]', 'gu');

export function chiaveRicerca(testo?: string | null): string {
  return (testo || '').replace(NON_ALFANUMERICO, '').toUpperCase();
}

/** `testo` contiene `cercato` ignorando simboli e maiuscole. Un testo cercato
 * di soli simboli si confronta com'è. */
export function contieneRicerca(testo?: string | null, cercato?: string | null): boolean {
  const k = chiaveRicerca(cercato);
  if (!k) {
    const q = (cercato || '').trim().toLowerCase();
    return !!q && (testo || '').toLowerCase().includes(q);
  }
  return chiaveRicerca(testo).includes(k);
}

/** `testo` è uguale a `cercato` ignorando simboli e maiuscole. */
export function ugualeRicerca(testo?: string | null, cercato?: string | null): boolean {
  const k = chiaveRicerca(cercato);
  return !!k && chiaveRicerca(testo) === k;
}
